export const quranTrackingEn = {
  // Quran progress
  lastSession: 'Last Session',
  nextSession: 'Next Session',
  note: 'Note',
  
  // Hifz - Memorization
  newHifzTxt: 'New Memorization',
  nextHalaqaNewHifzText: 'Memorization for Next Halaqa',
  
  // Murajah - Review
  oldHifzMurajahTxt: 'Old Hifz Review',
  newHifzMurajahText: 'New Hifz Review',
  nextHalaqaOldHifzMurajahText: 'Old Hifz Review for Next Halaqa',
  nextHalaqaNewHifzMurajahText: 'New Hifz Review for Next Halaqa',

  // Actions & labels
  absent: 'Absent',
  edit: 'Edit',
  cancel: 'Cancel',
  save: 'Save',
  saving: 'Saving...',
  savingEvals: 'Saving...',
  evaluation: 'Evaluation',
  repeatLastHifz: 'Repeat Last Hifz',
  repeatNewHifzLabel: 'Repeat New Hifz',
  times: 'times',
  mustRepeatPart1: 'The student must repeat the new Hifz',
  mustRepeatPart2: 'then update the value',
  sortByLastSession: 'Last session date',

  // Evaluation options
  evalExcellent: 'Excellent',
  evalGood: 'Good',
  evalMoyen: 'Average',
  evalRepeat: 'Repeat',
  evalAbsent: 'Absent',
  evalNotDone: 'Not done',
};
